import React from "react";


function CheckView(inView,entry) {

    if(inView){
        entry.target.firstChild.classList.add('inView')

    }
    else{
        entry.target.firstChild.classList.remove('inView')
    }
    return true
}
export default CheckView;